const config = {
   // apiUrl: process.env.NODE_ENV === "production" ? "/api" : "https://newpanel.adakchoob.com/api",
   apiUrl: process.env.NODE_ENV === "production" ? "/api" : "http://localhost:5000/api",
};

export default config;
